import React from 'react';
import { css } from '@emotion/css';
import classNames from 'classnames';

const commonStyle = css`
  border: 1px solid #babcbf;
  border-radius: 2px;
`;

/** @type {React.FC<import('react').InputHTMLAttributes>} */
export const InputText = ({ className, ...rest }) => (
  <input className={classNames(className, ['form-input', 'm-r-1'], commonStyle)} {...rest} />
);

/** @type {React.FC<import('react').TextareaHTMLAttributes>} */
export const TextArea = ({ className, ...rest }) => (
  <textarea className={classNames(className, ['form-input'], commonStyle)} {...rest} />
);
